// Browser storage that belongs to one person: the weekly report's pinned
// leader's note. Each value is kept under `<name>:<userId>`, so whoever signs
// in next on this browser can't inherit it. The bare names are what older
// builds wrote; nothing reads them, and sign-out removes them, as it does the
// day The Brief was last dismissed (now the server's briefFoldedOn).

export const PINNED_NOTE_KEY = 'cadence_leader_note_pinned';
const LEGACY_BRIEF_DISMISSED_KEY = 'cadence_brief_dismissed_date';

const PER_PERSON_KEYS = [LEGACY_BRIEF_DISMISSED_KEY, PINNED_NOTE_KEY];

/** `name` for this person, or null when nobody is signed in. */
export function personKey(name: string, userId: string | null | undefined): string | null {
  return userId ? `${name}:${userId.toLowerCase()}` : null;
}

export function readPersonItem(name: string, userId: string | null | undefined): string | null {
  const key = personKey(name, userId);
  if (!key) return null;
  try { return localStorage.getItem(key); } catch { return null; }
}

export function writePersonItem(name: string, userId: string | null | undefined, value: string): void {
  const key = personKey(name, userId);
  if (!key) return;
  try { localStorage.setItem(key, value); } catch { /* private browsing / quota */ }
}

export function removePersonItem(name: string, userId: string | null | undefined): void {
  const key = personKey(name, userId);
  if (!key) return;
  try { localStorage.removeItem(key); } catch { /* private browsing */ }
}

/**
 * Drops the unkeyed values older builds left (anyone signing in next would
 * have inherited them) and, given a user id, that person's own values too.
 */
export function clearPersonStorage(userId?: string | null): void {
  for (const name of PER_PERSON_KEYS) {
    try { localStorage.removeItem(name); } catch { /* private browsing */ }
    removePersonItem(name, userId);
  }
}
